import { createContext, useContext, useMemo, useRef } from 'react';

const ViewingRelayContext = createContext(null);

export const ViewingRelayProvider = ViewingRelayContext.Provider;

// What the activity on screen has said about itself, for the next message to carry. A ref
// because nothing renders from it — it is read once, as a message is sent — and because the
// alternative re-renders the page every time the student steps between the parts of a question.
export default function useViewingRelay() {
  const viewingRef = useRef(null);

  return useMemo(
    () => ({
      readViewing: () => viewingRef.current,
      reportViewing: fragment => {
        viewingRef.current = fragment;
      },
    }),
    [],
  );
}

// For the activity on screen to say what only it knows: which part of a multipart question is
// open, which question of a quiz and its number on the rail, the answer standing in it before the
// debounced save lands, and how far into a video they are. Returns undefined outside a relay, so the
// same activity components render unchanged everywhere else.
export function useViewingReporter() {
  return useContext(ViewingRelayContext)?.reportViewing;
}

export function useReadViewing() {
  return useContext(ViewingRelayContext)?.readViewing;
}
